import { transformObjectToArray } from '../../../ticketing.helper';
import { Data } from './elements.type';

export const transform = (data: Record<string, Data> | Data[]): Data[] => {
  if (!Array.isArray(data)) return transformObjectToArray(data);

  return data;
};
